import Seo from "../components/Seo";

export default function Terms() {
  return (
    <>
      <Seo title="Terms of Use" description="Terms of use for hslibraryhangout.com and HS Library Hangout events." />
      <h1>Terms of Use</h1>

      <section className="card">
        <h2>Acceptance of terms</h2>
        <p>
          By using hslibraryhangout.com or attending an HS Library Hangout event, you agree to these
          terms.
        </p>
      </section>

      <section className="card">
        <h2>Independent organization</h2>
        <p>
          HS Library Hangout is an independently organized parent group. It is not sponsored, managed,
          approved, or endorsed by Oak Lawn Public Library. Library staff do not manage events,
          registrations, supervision, or questions for this group.
        </p>
      </section>

      <section className="card">
        <h2>RSVP responsibilities</h2>
        <p>
          RSVPs must be submitted by an adult parent or guardian on behalf of their own teen(s). By
          submitting an RSVP, you confirm you are that adult and agree to our Safety &amp; Code of Conduct
          and Privacy Policy.
        </p>
      </section>

      <section className="card">
        <h2>No guarantee of supervision or childcare</h2>
        <p>
          While a parent organizer is present during events, HS Library Hangout does not provide childcare,
          professional supervision, or therapeutic services. Parents remain responsible for their own
          teens.
        </p>
      </section>

      <section className="card">
        <h2>Assumption of risk</h2>
        <p>
          Attendance at events is voluntary. Parents and teens assume all risks associated with attending a
          public library meeting room gathering.
        </p>
      </section>

      <section className="card">
        <h2>Changes to these terms</h2>
        <p>We may update these terms from time to time; continued use of the site constitutes acceptance.</p>
      </section>

      <section className="card">
        <h2>Contact</h2>
        <p>
          Questions about these terms? <a href="/contact">Contact us</a>.
        </p>
      </section>
    </>
  );
}
